import React, { useState } from "react";
import { motion } from "framer-motion";
import FlatLayPopover from "./FlatLayOverlay";

const PeriodicTile = ({ scent, index, selected, disabled, onClick }) => {
  const [preview, setPreview] = useState(false);

  return (
    <div className="relative">
      <motion.button
        type="button"
        data-testid={`scent-tile-${scent.symbol}`}
        onClick={() => onClick(scent)}
        onMouseEnter={() => setPreview(true)}
        onMouseLeave={() => setPreview(false)}
        onFocus={() => setPreview(true)}
        onBlur={() => setPreview(false)}
        disabled={disabled}
        whileTap={{ scale: 0.97 }}
        className={[
          "group relative aspect-square w-full text-left p-3 md:p-4 overflow-hidden",
          "bg-white border border-black rounded-none",
          "transition-all duration-200",
          selected
            ? "brutal-shadow-pink-lg -translate-x-0.5 -translate-y-0.5"
            : "brutal-shadow hover:brutal-shadow-pink",
          disabled && !selected ? "opacity-40 cursor-not-allowed" : "",
        ].join(" ")}
        style={
          selected
            ? {
                background: `linear-gradient(160deg, ${scent.color}30, #ffffff 65%)`,
                borderColor: "#FF1493",
              }
            : {}
        }
      >
        <div className="absolute top-1.5 left-2 overline text-[9px] text-black/60 z-10">
          {String(scent.atomic_number).padStart(2, "0")}
        </div>
        <div className="absolute top-1.5 right-2 flex items-center gap-1 z-10">
          <span
            className="inline-block w-2.5 h-2.5 rounded-full border border-black/60"
            style={{ background: scent.color }}
          />
        </div>
        {!selected ? (
          <div className="relative z-10 h-full flex flex-col items-center justify-center pt-3">
            <div className="font-serif-display font-black text-3xl md:text-4xl leading-none">
              {scent.symbol}
            </div>
            <div className="mt-2 text-center">
              <div className="font-sans-display text-sm font-semibold leading-tight">
                {scent.name}
              </div>
              <div className="overline text-[8px] mt-0.5 text-black/60">
                {scent.category}
              </div>
            </div>
          </div>
        ) : (
          <div className="relative z-10 h-full flex flex-col pt-4">
            <div className="flex items-baseline gap-2">
              <div
                className="font-serif-display font-black text-2xl leading-none"
                style={{ color: "#FF1493" }}
              >
                {scent.symbol}
              </div>
              <div className="font-sans-display text-xs font-semibold">
                {scent.name}
              </div>
            </div>
            <div className="mt-2 flex-1 overflow-hidden">
              <div className="overline text-[8px] text-black/50 mb-1">
                {scent.category}
              </div>
              {scent.notes && scent.notes.length > 0 && (
                <div className="flex flex-wrap gap-0.5">
                  {scent.notes.slice(0, 8).map((n) => (
                    <span
                      key={n}
                      className="text-[8px] leading-tight bg-white/85 border border-black/40 px-1 py-0.5"
                    >
                      {n}
                    </span>
                  ))}
                  {scent.notes.length > 8 && (
                    <span className="text-[8px] text-black/50 self-center">
                      +{scent.notes.length - 8}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {selected && (
          <div className="absolute -top-2 -right-2 bg-[#FF1493] text-white w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-bold border border-black z-20">
            ✓
          </div>
        )}
      </motion.button>

      <FlatLayPopover scent={scent} visible={preview} />
    </div>
  );
};

export default PeriodicTile;
